import { render, staticRenderFns } from "./PlanItem.vue?vue&type=template&id=8f21022c&scoped=true"
import script from "./PlanItem.vue?vue&type=script&lang=js"
export * from "./PlanItem.vue?vue&type=script&lang=js"
import style0 from "./PlanItem.vue?vue&type=style&index=0&id=8f21022c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f21022c",
  null
  
)

export default component.exports